export function extractSegregateTradesList(response) {
  if (Array.isArray(response)) return response;
  if (Array.isArray(response?.data)) return response.data;
  if (Array.isArray(response?.trades)) return response.trades;
  return [];
}

export function normalizeSegregateModalTrade(trade) {
  const transaction = trade.transaction_type ?? trade.transaction ?? trade.transitions ?? "-";
  return {
    ...trade,
    id: trade.id,
    symbol: trade.exchange_trading_symbol || trade.symbol || trade.trading_symbol || "-",
    clientId: trade.broker_client_code || trade.broker_code || "-",
    qtyLots: trade.traded_quantity ?? trade.total_qty ?? trade.qty_lots ?? "-",
    transitions: transaction,
    timestamp: trade.trade_timestamp || trade.date_time || trade.timestamp || "-",
    transactionType: String(transaction).toUpperCase().includes("SELL") ? "Sell" : "Buy",
  };
}

export function normalizeSegregateModalTrades(trades) {
  if (!Array.isArray(trades)) return [];
  return trades.map(normalizeSegregateModalTrade);
}

export function filterSegregateModalTrades(trades, filters) {
  const {
    symbol,
    brokerCode,
    strategy,
    strike,
    batchId,
    instrumentType,
    transactionType,
  } = filters;

  return trades.filter((trade) => {
    if (symbol && symbol !== "all") {
      const exchange = String(trade.exchange || "").toUpperCase();
      if (exchange && exchange !== symbol.toUpperCase()) {
        return false;
      }
    }
    if (brokerCode && brokerCode !== "all") {
      const exchange = String(trade.exchange || "").toUpperCase();
      if (exchange && exchange !== brokerCode.toUpperCase()) {
        return false;
      }
    }
    if (strategy && strategy !== "all" && trade.strategy_name && trade.strategy_name !== strategy) {
      return false;
    }
    if (strike && strike !== "all") {
      const strikeValue = trade.strike_price ?? trade.strike;
      if (strikeValue != null && String(strikeValue) !== String(strike)) {
        return false;
      }
    }
    if (batchId) {
      if (!trade.batch_id || !String(trade.batch_id).includes(String(batchId))) {
        return false;
      }
    }
    if (instrumentType && instrumentType !== "all") {
      const typeValue = String(trade.instrument_type || trade.symbol_type || trade.option_type || "").toUpperCase();
      if (typeValue && typeValue !== instrumentType.toUpperCase()) {
        return false;
      }
    }
    if (transactionType && trade.transactionType !== transactionType) {
      return false;
    }
    return true;
  });
}
